import SiteHeader from "./components/SiteHeader";
import HeroSection from "./components/HeroSection";
import HeadlineSection from "./components/HeadlineSection";
import LatestUpdates from "./components/LatestUpdates";
import TopicSection from "./components/TopicSection";
import TrendingSection from "./components/TrendingSection";
import TrustFaqSection from "./components/TrustFaqSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full flex-1">
        <HeroSection />
        <HeadlineSection />
        <LatestUpdates />
        <TopicSection />
        <TrendingSection />
        <TrustFaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}